import React, { useState, useEffect } from 'react';

function ContactHeader() {
  const [minHeight, setMinHeight] = useState("clamp(12.5rem, 60vw, 21rem)");

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setMinHeight("30rem");
      } else {
        setMinHeight("clamp(12.5rem, 60vw, 21rem)");
      }
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <header className="container relative lg:mt-20" style={{ minHeight: minHeight }}>
      <img 
        src="/images/lego-helpdesk.jpeg" 
        alt="Shapes" 
        className="absolute inset-0 object-cover w-full h-full"
        style={{ minHeight: "100%", minWidth: "100%", objectFit: "cover" }}
      />
    </header>
  );
}

export default ContactHeader;
